import { Card } from "antd";
import {
  FaClinicMedical,
  FaEnvelope,
  FaMapMarkerAlt,
  FaPhone,
  FaPlus,
} from "react-icons/fa";
import { IoMdRadioButtonOff, IoMdRadioButtonOn } from "react-icons/io";
import { useLanguage } from "../../context/LanguageContext";
import { LuEye } from "react-icons/lu";
import { useState } from "react";
import { ClinicDetailsModal } from "../HomeSections/DoctorInfo";
import { useNavigate } from "react-router-dom";
import { slug } from "../../utils/store";
import GuestBookingModal from "../Modals/GuestInformationModal";
import LoginModal from "../Modals/LoginModal";
import NeedAuthModal from "../Modals/NeedAuthModal";
import { Circle } from "lucide-react";

export default function CliniSelect({ clinics, onSelect, selectedClinic }) {
  const { t } = useLanguage();
  const [expandedClinic, setExpandedClinic] = useState(null); 
    const navigate = useNavigate();
      const [pendingRoute, setPendingRoute] = useState(null);
const [isModalVisible, setIsModalVisible] = useState(false);      // جديد
const [isGuestModalVisible, setIsGuestModalVisible] = useState(false); // جديد
const [loginModal, setLoginModal] = useState(false);              // جديد
const [registerModal, setRegisterModal] = useState(false);        // جديد

const handleProtectedNavigation = (route) => {
  if (!isAuthorized) {
    setPendingRoute(route);
    setIsModalVisible(true); 
  } else {
    navigate(route);
  }
};

const handleGuestBooking = () => {
  setIsModalVisible(false);
  setIsGuestModalVisible(true);
};

const handleGuestInfoSubmit = (guestInfo) => {
  setIsGuestModalVisible(false);
  sessionStorage.setItem(`guestInfo-${slug}`, JSON.stringify(guestInfo));
  sessionStorage.setItem(`isGuestBooking-${slug}`, "true");
  navigate(pendingRoute || `/book-appointment`);
};
  const isAuthorized =
    !!localStorage.getItem(`userTkn-${slug}`) ||
    !!sessionStorage.getItem(`userTkn-${slug}`);


  if (clinics.length === 0) {
    return (
      <Card className="border-2 border-dashed border-placeHolder bg-cardColor rounded-xl">
        <div className="flex flex-col items-center justify-center py-8 px-4 text-center">
          <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mb-4">
            <FaClinicMedical className="text-3xl text-placeHolder" />
          </div>
          <h3 className="text-lg font-medium text-textPrimary mb-2">
            {t("clinicSelect.noClinics.title")}
          </h3>
          <p className="text-placeHolder text-sm mb-4 max-w-md">
            {t("clinicSelect.noClinics.description")}
          </p>
          <div className="flex items-center gap-2 text-placeHolder text-xs">
            <FaPlus className="text-sm" />
            <span>{t("clinicSelect.noClinics.footer")}</span>
          </div>
        </div>
      </Card>
    );
  }

  return (
    <div className="space-y-3">
      {/* Header */}
      <h2 className="text-lg font-semibold text-textPrimary flex items-center gap-2">
        <FaClinicMedical className="text-primary text-xl" />
        {t("clinicSelect.title")}
      </h2>

      {/* Clinic Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        {clinics.map((clinic) => {
          const isSelected = selectedClinic?.clinicId === clinic.clinicId;
          return (
            <Card
              key={clinic.clinicId}
              onClick={() => onSelect(clinic)}
              className={`border cursor-pointer transition-all bg-cardColor text-textPrimary rounded-xl ${
                isSelected
                  ? "border-textPrimary bg-primary text-white"
                  : "border-placeHolder"
              }`}
              bodyStyle={{ padding: "12px" }}
            >
              <div className="flex flex-col gap-2">
                {/* Top Row: Radio Button and Clinic Name */}
                <div className="flex items-center gap-2">
                  {isSelected ? (
                    <IoMdRadioButtonOn className="text-xl text-secondary" />
                  ) : (
                    <IoMdRadioButtonOff className="text-xl text-textPrimary" />
                  )}
                  <h3 className="text-base font-medium">{clinic.clinicName}</h3>
                </div>

                {/* select Button */}
                <button
                  className={`bg-white mt-2 text-center flex justify-center text-primary border border-primary font-semibold py-2 px-4 rounded-lg hover:bg-goldy  hover:text-white transition-colors shadow-md flex items-center gap-2`}
                  
                >
                  {/* <Circle className="text-xs h-3 w-3" /> */}
                  {t("clinics.details.select")}
                </button>
              </div>
            </Card>
          );
        })}
      </div>

      {/* Clinic Details Modal */}
      {expandedClinic && (
        <ClinicDetailsModal
          clinic={clinics.find((c) => c.clinicId === expandedClinic)}
          isOpen={!!expandedClinic}
          onClose={() => setExpandedClinic(null)}
          t={t}
          handleProtectedNavigation={handleProtectedNavigation} 
          hide={true}
        />
      )}
      <NeedAuthModal
  open={isModalVisible}
  onConfirm={() => {
    setIsModalVisible(false);
    setLoginModal(true);
  }}
  onCancel={() => {
    setIsModalVisible(false);
    setPendingRoute(null);
  }}
  onGuestBooking={handleGuestBooking}
/>
<LoginModal
  setRegisterModal={setRegisterModal}
  isRegister={registerModal}
  loginModal={loginModal}
  setLoginModal={setLoginModal}
/>
<GuestBookingModal
  open={isGuestModalVisible}
  onCancel={() => {
    setIsGuestModalVisible(false);
    setPendingRoute(null);
  }}
  onSubmit={handleGuestInfoSubmit}
/>
    </div>
  );
}